import { render, staticRenderFns } from "./SponsoredRecommendationImage.vue?vue&type=template&id=ce097386&scoped=true"
import script from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImage.vue?vue&type=style&index=0&id=ce097386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce097386",
  null
  
)

export default component.exports